import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await login(form.email, form.password);
      toast.success("Welcome back.");
      nav("/dashboard");
    } catch (e2) {
      const msg = formatErr(e2.response?.data?.detail) || "Could not sign in.";
      setErr(msg);
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="login-page" className="section-pad container-luxe max-w-md">
      <p className="overline">Sign in</p>
      <h1 className="font-display text-4xl text-aubergine mt-4">Welcome back.</h1>
      <p className="mt-3 text-plumSoft font-light">Continue where you left off.</p>
      <form onSubmit={submit} className="mt-10 card-luxe p-8 space-y-5">
        <div>
          <label className="label-luxe">Email</label>
          <input data-testid="login-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="input-luxe" />
        </div>
        <div>
          <div className="flex items-center justify-between">
            <label className="label-luxe">Password</label>
            <Link to="/forgot-password" data-testid="login-forgot-link" className="text-[10px] tracking-[0.18em] uppercase text-plum hover:text-aubergine">Forgot password?</Link>
          </div>
          <input data-testid="login-password" required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="input-luxe" />
        </div>
        {err && <p data-testid="login-error" className="text-sm text-destructive">{err}</p>}
        <button data-testid="login-submit" disabled={busy} className="btn-primary w-full">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
      <p className="text-sm text-plumSoft mt-6 text-center font-light">
        New here? <Link to="/register" data-testid="login-register-link" className="text-plum link-underline">Create an account</Link>
      </p>
    </div>
  );
}
